/* topiary home page, desktop (8 Oct 2026; plan Docs/footer-home-build-plan-2026-10-08.md): the next-day band's arrival date
   and countdown. Same rule as the Essential Estimated Delivery app on product pages: dispatch on a working day (Monday to
   Friday, not a closed date) if ordered before the cut-off (UK time), otherwise the next working day; arrival the working
   day after dispatch. Fail closed: if the UK time can't be read, the date line stays hidden. Runs only where the new home
   shows (1025 px and wider, browsers with :has). Also adds the best sellers' cards (first block below). */
// Best sellers: the cards wait in a <template data-tp-best> unless the page loaded at desktop width (the inline script in
// topiary-home-top.liquid). Add them if the window crosses into desktop later, or when the theme editor reloads the section.
// Cards added after load may miss their BSS badges until the next page load (the app labels the cards present when it runs).
(() => {
  'use strict';
  const DESKTOP = window.matchMedia('(min-width: 1025px)');
  const HAS = window.CSS && CSS.supports && CSS.supports('selector(:has(*))');
  function stamp(root) {
    if (!HAS || !DESKTOP.matches) return;
    (root || document).querySelectorAll('template[data-tp-best]').forEach((t) => t.replaceWith(t.content.cloneNode(true)));
  }
  stamp();
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', () => stamp());
  document.addEventListener('shopify:section:load', (e) => stamp(e.target));
})();

(() => {
  'use strict';
  const box = document.querySelector('[data-tp-arrival]');
  if (!box) return;
  const DESKTOP = window.matchMedia('(min-width: 1025px)');
  const HAS = window.CSS && CSS.supports && CSS.supports('selector(:has(*))');
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const pad = (n) => String(n).padStart(2, '0');
  const cutoffHour = Math.min(23, Math.max(0, parseInt(box.getAttribute('data-cutoff-hour'), 10) || 16));
  const closed = (box.getAttribute('data-closed') || '').split(/[\s,]+/).map((x) => x.trim()).filter((x) => /^(\d{4}-)?\d{2}-\d{2}$/.test(x));

  let fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  } catch (e) { return; }

  // UK wall-clock parts of an instant
  function uk(ms) {
    const o = {};
    for (const p of fmt.formatToParts(new Date(ms))) o[p.type] = p.value;
    return { y: +o.year, m: +o.month - 1, d: +o.day, h: +o.hour % 24, min: +o.minute, s: +o.second };
  }
  // the instant at which UK wall-clock shows y-m-d h:00
  function ukInstant(y, m, d, h) {
    const guess = Date.UTC(y, m, d, h, 0, 0);
    const w = uk(guess);
    const wall = Date.UTC(w.y, w.m, w.d, w.h, w.min, w.s);
    return guess - (wall - guess);
  }
  const key = (dt) => dt.getUTCFullYear() + '-' + pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate());
  function working(dt) {
    const wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    const k = key(dt);
    return !closed.some((c) => c === k || c === k.slice(5));
  }
  const nextWorking = (dt) => { const n = new Date(dt.getTime()); do { n.setUTCDate(n.getUTCDate() + 1); } while (!working(n)); return n; };

  const el = { date: box.querySelector('[data-tp-arrival-date]'), h: box.querySelector('[data-tp-h]'), m: box.querySelector('[data-tp-m]'), s: box.querySelector('[data-tp-s]'),
    cm: box.querySelector('[data-tp-cal-m]'), cd: box.querySelector('[data-tp-cal-d]'), cw: box.querySelector('[data-tp-cal-w]') };
  let timer = null;

  function plan(now) {
    const t = uk(now);
    let dispatch = new Date(Date.UTC(t.y, t.m, t.d));           // a calendar date, held at UTC midnight
    if (!working(dispatch) || t.h >= cutoffHour) dispatch = nextWorking(dispatch);
    const arrival = nextWorking(dispatch);
    const cutoff = ukInstant(dispatch.getUTCFullYear(), dispatch.getUTCMonth(), dispatch.getUTCDate(), cutoffHour);
    return { arrival, cutoff };
  }

  function tick() {
    const now = Date.now();
    const p = plan(now);
    const left = Math.max(0, Math.floor((p.cutoff - now) / 1000));
    if (!(left > 0) || left > 8 * 86400) { box.hidden = true; return; }   // sanity: never show a stale or absurd countdown
    const text = 'Arrives ' + DAYS[p.arrival.getUTCDay()] + ' ' + p.arrival.getUTCDate() + ' ' + MONTHS[p.arrival.getUTCMonth()];
    if (el.date.textContent !== text) {
      el.date.textContent = text;
      // the calendar badge (as on the product page): short month, day, short weekday
      if (el.cm) el.cm.textContent = MONTHS[p.arrival.getUTCMonth()].slice(0, 3).toUpperCase();
      if (el.cd) el.cd.textContent = String(p.arrival.getUTCDate());
      if (el.cw) el.cw.textContent = DAYS[p.arrival.getUTCDay()].slice(0, 3);
    }
    el.h.textContent = pad(Math.floor(left / 3600));
    el.m.textContent = pad(Math.floor((left % 3600) / 60));
    el.s.textContent = pad(left % 60);
    if (box.hidden) box.hidden = false;
  }

  function start() {
    if (timer) return;
    if (!HAS || !DESKTOP.matches) return;
    try { tick(); } catch (e) { box.hidden = true; return; }
    timer = setInterval(() => { try { tick(); } catch (e) { box.hidden = true; clearInterval(timer); timer = null; } }, 1000);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  start();
  DESKTOP.addEventListener ? DESKTOP.addEventListener('change', () => (DESKTOP.matches ? start() : stop())) : null;
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
})();
